var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('ul',[_c('li',{class:_vm.msgClass,domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._l((_vm.inputErrors),function(value,key){return _c('li',{key:key,class:_vm.msgClass},[_vm._v(" "+_vm._s(value)+" ")])})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }